import React from 'react';
import { Route } from 'react-router-dom';
import Contacts from '../pages/contacts/Contacts';
import ContactDetails from '../pages/contacts/ContactDetails';
import ContactSection from '../pages/contacts/ContactSection';
import ProtectedRoute from '../components/global/ProtectedRoute';

const contactsRoutes = (
    <>
        {/* Contact Section */}
        <Route
            path="/contacts/section"
            element={
                <ProtectedRoute requiredPermission="viewAny-contact-section">
                    <ContactSection />
                </ProtectedRoute>
            }
        />

        <Route
            path="/contacts"
            element={
                <ProtectedRoute>
                    <Contacts />
                </ProtectedRoute>
            }
        />

        <Route
            path="/contacts/:id"
            element={
                <ProtectedRoute>
                    <ContactDetails />
                </ProtectedRoute>
            }
        />
    </>
);

export default contactsRoutes;
